import { getP44Env } from '@project44/ui-utils';

export const BASE_URL = process.env.IS_LOCAL
  ? 'https://localhost.api.qa-integration.p-44.com:3000'
  : `${getP44Env().GATEWAY_API_BASE_URL}/shipment-list-gateway`;
